import {OverviewState} from './overview.state';
import {DirectionDTO} from '../../../../openapi/agrarinformationen-openapi';


export const overviewStateInitial: OverviewState = {
  newsIds: [],
  totalElements: 0,
  pageableDto: {
    size: 4,
    number: 0,
    property: ['createdAt'],
    direction: [DirectionDTO.Desc],
  },
  loading: false,
  loaded: false,
}
